/**
 * @generated SignedSource<<c108279602c1c301e56cceb583ca1c42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type TeamNavigatorNoTeam_store$data = {
  readonly currentEmployee: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_employee">;
  } | null;
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_storeUser">;
  } | null;
  readonly myRole: Roles;
  readonly " $fragmentType": "TeamNavigatorNoTeam_store";
};
export type TeamNavigatorNoTeam_store$key = {
  readonly " $data"?: TeamNavigatorNoTeam_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigatorNoTeam_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigatorNoTeam_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "employeeId"
        }
      ],
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "currentEmployee",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_employee"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_storeUser"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "a3c65efeb9f4d3a126b6c702f7d5dc08";

export default node;
